import { useEffect } from "react";
import { attachTagToChat, detachTagFromChat } from "../../api/whatsapp.js";
import type { ChatTag, WhatsappChat } from "../../types.ts";
import type { TagPickerState } from "./types.ts";

type TagPickerProps = {
  chat: WhatsappChat;
  tags: ChatTag[];
  position: TagPickerState;
  onClose: () => void;
  onError: (message: string) => void;
};

export function TagPicker({
  chat,
  tags,
  position,
  onClose,
  onError,
}: TagPickerProps) {
  const attached = new Set(chat.tagIds || []);

  useEffect(() => {
    const close = () => onClose();
    window.setTimeout(() => document.addEventListener("click", close, { once: true }), 0);
    return () => document.removeEventListener("click", close);
  }, [onClose]);

  async function toggleTag(tag: ChatTag) {
    try {
      if (attached.has(tag.id)) await detachTagFromChat(chat.chatJid, tag.id);
      else await attachTagToChat(chat.chatJid, tag.id);
    } catch (err) {
      onError(err instanceof Error ? err.message : "Falha");
    }
  }

  return (
    <div
      className="wa-tag-picker"
      style={{ left: position.x, top: position.y }}
      onClick={(event) => event.stopPropagation()}
    >
      <div className="wa-tag-picker-title">Tags do contato</div>
      {tags.length ? tags.map((tag) => {
        const isOn = attached.has(tag.id);
        return (
          <button key={tag.id} className="wa-tag-picker-item" type="button" onClick={() => void toggleTag(tag)}>
            <span className="wa-tag-picker-check">{isOn ? "OK" : ""}</span>
            <span className="wa-tag-picker-dot" style={{ background: tag.color }} />
            <span className="wa-tag-picker-name">{tag.name}</span>
          </button>
        );
      }) : <div className="wa-tag-picker-empty">Nenhuma tag criada ainda. Use "+ Tag" na sidebar.</div>}
    </div>
  );
}
